export default class GetCounterByPartitionKeyAndResourceTypeError extends Error {

}
